module.exports = __webpack_public_path__ + "static/media/itk.27506cdb.jpeg";